import { AnalyticsService } from 'services/Analytics/AnalyticsService';

AnalyticsService.init();
import('./bootstrap');
